/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import { Box, Typography } from '@mui/material';
import type { SxProps } from '@mui/system/styleFunctionSx';
import { type ReactNode } from 'react';

export function SidebarSectionHeader( { title, description, sx }: { title: string; description: string; sx?: SxProps } ): ReactNode {
	return (
		<Box sx={ { ...sx, maxWidth: '80%' } }>
			<Typography color={ 'text.primary' } fontSize={ '16px' } fontWeight={ 700 } lineHeight={ '24px' }>
				{ title }
			</Typography>
			<Typography color={ 'text.secondary' } fontSize={ '12px' } fontWeight={ 400 } lineHeight={ '20px' }>
				{ description }
			</Typography>
		</Box>
	);
}
